import { render, staticRenderFns } from "./candidate-list.vue?vue&type=template&id=163a7d3e&scoped=true&"
import script from "./candidate-list.vue?vue&type=script&lang=js&"
export * from "./candidate-list.vue?vue&type=script&lang=js&"
import style0 from "./candidate-list.vue?vue&type=style&index=0&id=163a7d3e&lang=scss&scoped=true&"
import style1 from "./candidate-list.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "163a7d3e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VPagination } from 'vuetify/lib/components/VPagination';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VPagination,VRow})
